import { forwardRef, useId } from 'react'
import { cn } from './cn'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: React.ReactNode
	hint?: React.ReactNode
	error?: React.ReactNode
	block?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
	{ label, hint, error, block = true, className, id, required, ...rest },
	ref,
) {
	const generatedId = useId()
	const textareaId = id ?? generatedId
	return (
		<div className={cn('form-control', block && 'w-full')}>
			{label && (
				<label htmlFor={textareaId} className="label pb-1.5">
					<span className="label-text font-medium text-sm">
						{label}
						{required && (
							<span className="text-error ml-0.5" aria-hidden="true">
								*
							</span>
						)}
					</span>
				</label>
			)}
			<textarea
				ref={ref}
				id={textareaId}
				required={required}
				className={cn(
					'input-refined w-full min-h-[80px] resize-y',
					error && 'border-error focus:border-error',
					className,
				)}
				aria-invalid={error ? true : undefined}
				aria-describedby={error || hint ? `${textareaId}-help` : undefined}
				{...rest}
			/>
			{(error || hint) && (
				<p
					id={`${textareaId}-help`}
					role={error ? 'alert' : undefined}
					className={cn('text-xs mt-1.5', error ? 'text-error' : 'text-base-content/60')}
				>
					{error ?? hint}
				</p>
			)}
		</div>
	)
})
